import { useSyncExternalStore } from 'react';

export const ANIMATION_WORD_DELAY_MS = 100;
export const ANIMATION_START_DELAY_MS = 550;
export const FEEDBACK_LINKS_INITIAL_DELAY_MS = 180;

export type FeedbackDirection = 'yes' | 'no';

export function getFeedbackStorageKey(petitionId: string): string {
	return `ai_summary_feedback_${petitionId}`;
}

export function getStoredFeedbackDirection(petitionId: string): FeedbackDirection | false {
	try {
		const value = localStorage.getItem(getFeedbackStorageKey(petitionId));
		if (value === 'yes' || value === 'no') return value;
		// Backward compat: old entries stored 'true' before direction was tracked
		if (value === 'true') return 'yes';
		return false;
	} catch {
		return false;
	}
}

export function storeFeedback(petitionId: string, direction: FeedbackDirection): void {
	try {
		localStorage.setItem(getFeedbackStorageKey(petitionId), direction);
	} catch {
		// localStorage may be unavailable (private browsing, storage quota, etc.)
	}
}

/**
 * Returns whether feedback has already been stored for the given petition. Kept for backward
 * compat in tests.
 */
export function hasStoredFeedback(petitionId: string): boolean {
	return getStoredFeedbackDirection(petitionId) !== false;
}

const NOOP_SUBSCRIBE = () => () => {};

export function useStoredFeedbackDirection(petitionId: string): FeedbackDirection | false | null {
	return useSyncExternalStore(
		NOOP_SUBSCRIBE,
		() => getStoredFeedbackDirection(petitionId),
		() => null,
	);
}

/** @deprecated Use useStoredFeedbackDirection */
export function useHasStoredFeedback(petitionId: string): boolean | null {
	const dir = useStoredFeedbackDirection(petitionId);
	if (dir === null) return null;
	return dir !== false;
}
